import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { Navbar, Profile, Header, WhatPortfolioX, Feature, Possibilities, Services, Users, User, Footer, QuickShare, Videos, VideoDashboard } from "./containers";
import { Brand, CTA } from "./components";
import { handleLoginUser, getUserData } from "./services/authSlice";
import app from "./services/firebaseinit";

const auth = getAuth(app);

const provider = new GoogleAuthProvider();

const App = () => {
  const [currentUrl, setCurrentUrl] = useState("");
  const dispatch = useDispatch();
  const handleLogin = () => {
    signInWithPopup(auth, provider).then((result) => {
      // This gives you a Google Access Token. You can use it to access the Google API.
      // const credential = GoogleAuthProvider.credentialFromResult(result);
      // const token = credential.accessToken;
      // The signed-in user info.
      // const user = JSON.parse(result.user);
      dispatch(handleLoginUser(result.user));
      // store user object in secure storage
      // console.log(result.user);
    }).catch((error) => {
      // Handle Errors here.
      const { message, code } = error;
      // The email of the user's account used.
      const { email } = error;
      // The AuthCredential type that was used.
      const credential = GoogleAuthProvider.credentialFromError(error);
      // ...
      console.log(code, message, email, credential);
    });
  };
  React.useEffect(() => {
    dispatch(getUserData("user"));
    setCurrentUrl(window.location.pathname);
  }, [0]);
  console.log(currentUrl);
  return (
    <Router>
      <Routes>
        <Route path="/user/video" element={<VideoDashboard />} />
      </Routes>
      <Navbar onBtnClicked={handleLogin} />
      <div className="min-h-screen iphone rounded">
        <Routes>
          <Route path="/" element={<Videos />} />
          <Route path="/portfoliax/profile" element={<Profile />} />
          <Route path="/portfoliax/share/:uid" element={<QuickShare />} />
          <Route path="/portfoliax/users" element={<Users />} />
          <Route path="/portfoliax/user/:uid" element={<User />} />
          <Route
            path="/portfoliax"
            element={
              (
                <>
                  <div className="gradient-bg-welcome">
                    <div className="gradient__bg">
                      <Header onBtnClicked={handleLogin} />
                    </div>
                  </div>
                  <div className="gradient-bg-welcome">
                    <Brand />
                  </div>
                  <div className="gradient__bg pt-5 rounded">
                    <WhatPortfolioX />
                  </div>
                  <div className="gradient-bg-feature rounded">
                    <Feature />
                  </div>
                  <div className="gradient-bg-welcome rounded">
                    <Possibilities />
                  </div>
                  <div className="gradient__bg pt-5 pb-5 rounded">
                    <CTA />
                  </div>
                  {/* <Projects /> */}
                  <Services />
                  <Footer onBtnClicked={handleLogin} />
                </>
              )
            }
          />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
